import React, { useState } from "react";
// import Snackbar from "@material-ui/core/Snackbar";
// import Slide from "@material-ui/core/Slide";
// import Alert from "@material-ui/lab/Alert";
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export default function withSnackbar( WrappedComponent ) {
    return props => {
        const [open, setOpen] = useState(false);
        const [message, setMessage] = useState("I'm a custom snackbar");
        const [duration, setDuration] = useState(2000);
        const [severity, setSeverity] = useState(
            "success"
        ); /** error | warning | info */

        const showMessage = (message, severity = "info", duration = 3000) => {
            setMessage(message);
            setSeverity(severity);
            setDuration(duration);
            setOpen(true);
        };

        const handleClose = (event, reason) => {
            if (reason === "clickaway") {
                return;
            }
            setOpen(false);
        };

        return (
            <>
                <WrappedComponent {...props} snackbarShowMessage={showMessage} />
                <Snackbar
                    anchorOrigin={{
                        vertical: "top",
                        horizontal: "right"
                    }}
                    autoHideDuration={duration}
                    open={open}
                    onClose={handleClose}
                    // TransitionComponent={Slide}
                >
                    <Alert onClose={handleClose} severity={severity} sx={{ width: '100%', marginTop: "50px" }}>
                        {message}
                    </Alert>
                    {/* <div variant="filled" onClose={handleClose} severity={severity}>
                        {message}
                    </div> */}
                </Snackbar>
            </>
        );
    };
};
